import { NavLink, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Star } from 'react-feather';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../context/authContext';
import filtroSolicitudesMatricula from '../../../helpers/filtroSolicitudesMatricula';
import colors from '../../../theme/colors';

const NavItemContainer = ({
  id,
  to,
  icon,
  title,
  toggle,
  className,
  suffix,
  esFavorito = false,
  onFavorito = undefined,
  arrastre = undefined,
}) => {
  const [badge, setBadge] = useState('');
  const { userOU } = useContext(AuthContext);

  useEffect(() => {
    const getFiltro = async () => {
      if (id === 5) {
        // Comprobamos que estamos en el botón de Matriculas

        const result = await filtroSolicitudesMatricula(userOU);
        setBadge(result.badge);
      }
    };

    getFiltro();

    // Establecer un intervalo para actualizar cada 15 segundos
    const intervalId = setInterval(() => {
      getFiltro();
    }, 7200000);

    return () => {
      clearInterval(intervalId); // Limpia el intervalo al desmontar el componente
    };
  }, [id, userOU]);

  return (
    <NavItem
      onClick={toggle}
      className={`navItemFav ${className || ''}${
        arrastre?.arrastrando ? ' navItemArrastrando' : ''
      }${arrastre?.encima ? ' navItemSoltarAqui' : ''}`}
      draggable={Boolean(arrastre)}
      onDragStart={arrastre?.onDragStart}
      onDragOver={arrastre?.onDragOver}
      onDragLeave={arrastre?.onDragLeave}
      onDrop={arrastre?.onDrop}
      onDragEnd={arrastre?.onDragEnd}
    >
      <NavLink tag={Link} to={to} className="gap-3" title={title}>
        <span className="sidebarIcon">{icon}</span>
        <span className="hide-mini w-100">
          <div className="d-flex align-items-center">
            <span>{title}</span>
            {badge !== 0 && (
              <span
                className="badge ms-auto"
                style={{
                  backgroundColor: `${colors.primary}20`,
                  color: colors.primary,
                  fontWeight: 600,
                  fontSize: '0.7rem',
                  borderRadius: '10px',
                  padding: '2px 8px',
                }}
              >
                {suffix !== '' ? suffix : badge}
              </span>
            )}
          </div>
        </span>
      </NavLink>
      {onFavorito && (
        <button
          type="button"
          className={`navFavBtn${esFavorito ? ' activo' : ''}`}
          aria-label={esFavorito ? `Quitar ${title} de favoritos` : `Añadir ${title} a favoritos`}
          aria-pressed={Boolean(esFavorito)}
          title={esFavorito ? 'Quitar de favoritos' : 'Añadir a favoritos'}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onFavorito();
          }}
        >
          <Star size={14} fill={esFavorito ? 'currentColor' : 'none'} />
        </button>
      )}
    </NavItem>
  );
};

NavItemContainer.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.node,
  toggle: PropTypes.func,
  className: PropTypes.string,
  suffix: PropTypes.node,
  esFavorito: PropTypes.bool,
  onFavorito: PropTypes.func,
  arrastre: PropTypes.object,
};

export default NavItemContainer;
